import { ToolData } from '../../types/tool';
import { FunctionComponent } from 'react';
import { Typography, Card, CardContent } from '../../tailwindcomponents';

type ToolsListProps = {
    tools: ToolData[],
}

const ToolsList: FunctionComponent<ToolsListProps> = ({ tools }) => {
    return (
        <Card style={{ backgroundColor: '#DCDCDC' }}>
            <CardContent>
                <Typography align="center" color="textPrimary" text={"Tools assigned to trip"} variant="h2" margin={[0, 0, 1, 0]} />
                {tools.map((tool, index) => (
                    <Card key={index} className="mb-4" style={{ backgroundColor: '#f1f5f9' }}>
                        <CardContent>
                            <div className="flex flex-row flex-wrap items-center justify-evenly" >
                                <div >
                                    <Typography align="center" color="textPrimary" text={tool.description} variant="h4" />
                                    <Typography align="center" color="textPrimary" text={tool.in_loan ? "Tool is in loan" : "Tool has been returned"} variant="h5" margin={[1, 0, 0, 0]} />
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                ))}
            </CardContent>
        </Card>
    );
}
export default ToolsList;